import { Outlet } from 'react-router';
import { UserMenu } from '../auth/UserMenu';
import { AppShell, type NavItem } from '../ui';

// No "Home" item: the app root (/) redirects an authenticated user to their garage, so the garage is
// the home. The brand logo links to /, which lands there; a separate Home button would look inert.
const NAV_ITEMS: readonly NavItem[] = [
  { to: '/garage', label: 'Garage' },
  { to: '/events', label: 'Discover' },
  { to: '/racing', label: 'Racing' },
];

/**
 * The layout for the authenticated application: the app chrome (header, navigation, sign-in status)
 * wrapping whichever routed page is active. The signed-out landing route deliberately sits outside
 * this layout so it can render full-bleed without the app navigation.
 *
 * @returns The shell layout element.
 */
export function AppShellLayout(): React.JSX.Element {
  return (
    <AppShell navItems={NAV_ITEMS} headerEnd={<UserMenu />}>
      <Outlet />
    </AppShell>
  );
}
